import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import Tooltip from '@material-ui/core/Tooltip';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import Button from '../../../components/button';
import Dropdown from './oneopt-autocomplete';
import ComponentErrorBoundary from '../../../components/component-error-boundary';
import Auth from '../../../auth/auth';
import Preloader from '../../../components/preloader';

import {connect} from 'react-redux';

const auth = new Auth();
export class DBConnection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dbName:"",
      dbUrl:"",
      dbUid:"",
      dbPwd:"",
      dbPort:"",
      serviceName:"",
      nameErrorStatus:false,
      nameErrorText:"",
      emailErrorStatus:false,
      emailErrorText:"",
      newPassword:"",
      newPasswordErrorStatus:false,
      showNewPassword:false,
      newPasswordErrorText:"",
      confirmPassword:"",
      confirmPasswordErrorStatus:false,
      confirmPasswordErrorText:"",
      showConfirmPassword:false,
      saveButtonStatus:true,
      dbTestStatus:"",
      dbTypes:["mssql","oracle"],
      dbType:null,
      formErrorState:['connError','dbName'],
      detectedSchemas: [],
      schemaStatusMessage: '',
      schemaLoading: false
    };
  }


  componentDidUpdate(prevProps) {
  if (this.props.dbData !== prevProps.dbData && this.props.dbData.length !==0) {
    this.setState({
      dbName:this.props.dbData.name,
      dbUrl:this.props.dbData.server,
      dbUid:this.props.dbData.user,
      // The stored credential is deliberately not sent to the browser, so the field
      // starts empty. Saving it blank leaves the stored password untouched.
      dbPwd:"",
      dbPort:this.props.dbData.port,
      dbType:this.props.dbData.type,
      serviceName:this.props.dbData.type === 'oracle' ? (this.props.dbData.serviceName || '') : '',
      newPassword:"",
      newPasswordErrorStatus:false,
      newPasswordErrorText:"",
      confirmPassword:"",
      confirmPasswordErrorStatus:false,
      confirmPasswordErrorText:"",
      saveButtonStatus:true,
      formErrorState:[]
    })
  }

  if (this.props.dbTestStatus !== prevProps.dbTestStatus){
    this.setState({dbTestStatus:this.props.dbTestStatus},()=>{this.enableSaveButton();});
    if(this.props.dbTestStatus===false){
      this.formErrorInsertValue('connError');
      this.setState({ detectedSchemas: [], schemaStatusMessage: '', schemaLoading: false });
    } else{
      this.formErrorRemoveValue('connError');
      this.loadDetectedSchemas();
    }
  }
 }

 cancelFlow=()=>{
    this.props.cancelFlow();
 }

 saveFlow=()=>{

   let dbObj={
     id:this.props.connId,
     name: this.state.dbName,
     server: this.state.dbUrl,
     user:this.state.dbUid,
     password:this.state.dbPwd,
     port:this.state.dbPort,
     type:this.state.dbType,
     orgId: Number(this.props.orgId)
   }

   if (this.state.dbType === 'oracle') {
     dbObj.serviceName = this.state.serviceName;
   }


   this.props.connId === null ? this.props.saveFlow(dbObj,'new',this.state.dbName) : this.props.saveFlow(dbObj,'update',this.state.dbName);

 }


 testConnection=()=>{

   let dbObj={
     dbUrl: this.state.dbUrl,
     dbUid:this.state.dbUid,
     dbPwd:this.state.dbPwd,
     type:this.state.dbType,
     dbPort:this.state.dbPort,
     orgId: Number(this.props.orgId)
   }

   if (this.state.dbType === 'oracle') {
     dbObj.serviceName = this.state.serviceName;
   }

   this.setState({ detectedSchemas: [], schemaStatusMessage: '', schemaLoading: false });

this.props.testDBConnect(dbObj);
 }

  extractSchemaNames = (payload) => {
    const response = payload?.response;
    const schemas = Array.isArray(response)
      ? response
      : Array.isArray(response?.schemas)
        ? response.schemas
        : [];

    return schemas
      .map((item) => (typeof item === 'string' ? item : item?.name))
      .filter(Boolean);
  }

  formatSchemaPreview = (schemas) => {
    if (!schemas || schemas.length === 0) return '';
    const preview = schemas.slice(0, 5).join(' · ');
    const remaining = schemas.length - 5;
    return remaining > 0 ? `${preview} and ${remaining} more` : preview;
  }

  loadDetectedSchemas = async () => {
    if (!this.props.connId) {
      this.setState({
        detectedSchemas: [],
        schemaLoading: false,
        schemaStatusMessage: 'Schema list is available after saving this connection.',
      });
      return;
    }

    this.setState({ schemaLoading: true, detectedSchemas: [], schemaStatusMessage: '' });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/db/connections/${this.props.connId}/schemas`,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': auth.getAccessToken()
          }
        }
      );

      const json = await response.json();
      if (!response.ok || json.status === false) {
        throw new Error(json.error || 'Schema load failed');
      }

      const schemas = this.extractSchemaNames(json);

      this.setState({
        detectedSchemas: schemas,
        schemaLoading: false,
        schemaStatusMessage: schemas.length === 0 ? 'No schemas found on this server.' : '',
      });
    } catch (error) {
      this.setState({
        detectedSchemas: [],
        schemaLoading: false,
        schemaStatusMessage: "Couldn't load schemas — check the connection",
      });
    }
  }

  handleTextfield = (event,item) => {
      this.setState({[item]:event.target.value});
  }


  formErrorRemoveValue=(attr)=>{
    if (this.state.formErrorState.find(o => o === attr)){
      this.setState({formErrorState:this.state.formErrorState.filter(val=> val !== attr)});
    }
  }

  formErrorInsertValue=(attr)=>{
    if (!this.state.formErrorState.find(o => o === attr)){
      this.setState({formErrorState:[...this.state.formErrorState,attr]});
    }
  }


  validateField=(field)=>{

    let errorStatus=field+"ErrorStatus";
    let errorText=field+"ErrorText";


    if(this.state[field].length>2)
    {
      if(field==="dbName"){
        this.checkNameDuplicates();
      } else{
        this.formErrorRemoveValue(field);
        this.setState({[errorStatus]:false,[errorText]:""},()=>{this.enableSaveButton();});
        return true;
      }
    }
    else{

      this.formErrorInsertValue(field);
      this.setState({[errorStatus]:true,[errorText]:"Invalid entry. Enter at least 2 characters."},()=>{this.enableSaveButton();});
      return false;
    }

  }


  checkNameDuplicates=()=>{
    let hasMatchingName = this.props.dbList.filter(function (item) { return item.name.toLowerCase() === event.target.value.toLowerCase(); });

    if(hasMatchingName.length !=0){

      if(hasMatchingName[0].connId!==this.props.connId){
        this.setState({dbNameErrorText:"You used this name already. Please try another.",dbNameErrorStatus:true},()=>{this.enableSaveButton();});
        this.formErrorInsertValue("dbName");
        return false;
      } else{
        this.setState({dbNameErrorText:"",dbNameErrorStatus:false},()=>{this.enableSaveButton();});
        this.formErrorRemoveValue("dbName");
        return true;
      }

    }

    else{
      this.setState({dbNameErrorText:"",dbNameErrorStatus:false},()=>{this.enableSaveButton();});
      this.formErrorRemoveValue("dbName");
      return true;
    }
  }




  enableSaveButton=()=>{
    if(this.state.formErrorState.length===0)
      {
      this.setState({saveButtonStatus:false});
      } else{
      this.setState({saveButtonStatus:true});
      }

}


handleClickShowPassword = (field) => {
    this.setState({[field]: !this.state[field] });
  };

 handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  dropdownSelector = (name,value) => {
              this.setState({[name]:value},()=>{this.enableSaveButton();});
              this.formErrorRemoveValue(name);
            }




   render() {

     const {isLoading} = this.props;
     let pageContent;
     let testDBStatus="";

     if(isLoading.includes('testconn')){
        testDBStatus=<Preloader loading={true} /> ;
      } else{
        if(this.state.dbTestStatus ===true){
          testDBStatus=<div className="display-status padding-20">
            <div>✓ The database connection was successful.</div>
            <div className="small-text muted">
              {
                this.state.schemaLoading
                  ? 'Detecting schemas...'
                  : this.state.detectedSchemas.length > 0
                    ? `${this.state.detectedSchemas.length} schemas detected: ${this.formatSchemaPreview(this.state.detectedSchemas)}`
                    : this.state.schemaStatusMessage
              }
            </div>
          </div>
        } else if(this.state.dbTestStatus ===false){
          testDBStatus=<div className="display-status padding-20"><i className='material-icons inactive'>circle</i>We couldn't connect to the database. Please check the details and try again.</div>
        } else {
         testDBStatus=""
       }
     }


     if(isLoading.includes('dbdetails')){
       pageContent=<Preloader loading={true} /> ;
     } else{
       pageContent=<div>
       <div className="rounded-card">

       <Row>
        <Col sm={3} xs={12}>
         <Dropdown
              label='Select database type'
              fileColumns={this.state.dbTypes}
              onSelectValue={this.dropdownSelector.bind(this,'dbType')}
              value={this.state.dbType} />
       </Col>
       </Row>

       <Row className='label-value-pair'>
         <Col sm={6} xs={12}>
        <ComponentErrorBoundary value="DB URL">
         <FormControl fullWidth>
          <InputLabel htmlFor="DB Url">URL</InputLabel>
          <Input
            type="text"
            value={this.state.dbUrl}
            onChange={(e)=>this.handleTextfield(e,"dbUrl")}
            error={this.state.urlErrorStatus}
          />
          <FormHelperText className="Mui-error">{this.state.urlErrorText}</FormHelperText>
         </FormControl>
         </ComponentErrorBoundary>
         </Col>
       </Row>

        {
          this.state.dbType === 'oracle' &&
          <Row className='label-value-pair'>
            <Col sm={6} xs={12}>
            <ComponentErrorBoundary value="Service Name">
            <FormControl fullWidth>
              <InputLabel htmlFor="DB Name">Service Name</InputLabel>
              <Input
                type="text"
                value={this.state.serviceName}
                onChange={(e)=>this.handleTextfield(e,"serviceName")}
                error={this.state.nameErrorStatus}
              />
              <FormHelperText className="Mui-error">{this.state.urlErrorText}</FormHelperText>
            </FormControl>
            </ComponentErrorBoundary>
            </Col>
          </Row>
        }

       <Row className='label-value-pair'>
         <Col sm={4} xs={12}>
        <ComponentErrorBoundary value="DB user id">
         <FormControl fullWidth>
          <InputLabel htmlFor="DB Id">Id</InputLabel>
          <Input
            type="text"
            value={this.state.dbUid}
            onChange={(e)=>this.handleTextfield(e,"dbUid")}
            error={this.state.dbUidErrorStatus}
          />
          <FormHelperText className="Mui-error">{this.state.dbUidErrorText}</FormHelperText>
         </FormControl>
         </ComponentErrorBoundary>
         </Col>
       </Row>

       <Row className='label-value-pair'>
         <Col sm={4} xs={12}>
         <ComponentErrorBoundary value="DB password">
         <FormControl fullWidth>
          <InputLabel htmlFor="DB password">Password</InputLabel>
          <Input
            type={this.state.showNewPassword ? 'text' : 'password'}
            value={this.state.dbPwd}
            inputProps={{maxLength: 50, 'data-testid': 'db-connection-password'}}
            autoComplete="new-password"
            onChange={(e)=>this.handleTextfield(e,"dbPwd")}
            onBlur={this.checkPasswordStrength}
            error={this.state.dbPwdErrorStatus}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={()=>this.handleClickShowPassword('showNewPassword')}
                  onMouseDown={(e)=>this.handleMouseDownPassword(e)}
                >
                  {this.state.showNewPassword ? <Tooltip title="Hide" placement="right"><i className="material-icons">visibility</i></Tooltip> : <Tooltip title="Show" placement="right"><i className="material-icons">visibility_off</i></Tooltip>}
                </IconButton>
              </InputAdornment>
            }
          />
          <FormHelperText className="Mui-error">{this.state.dbPwdErrorText}</FormHelperText>
          {this.props.connId !== null &&
            <FormHelperText data-testid="db-connection-password-hint">
              Leave blank to keep the current password. Enter it to test the connection.
            </FormHelperText>}
         </FormControl>
         </ComponentErrorBoundary>
         </Col>
       </Row>

       <Row className='label-value-pair'>
         <Col sm={4} xs={12}>
        <ComponentErrorBoundary value="DB port">
         <FormControl fullWidth>
          <InputLabel htmlFor="DB Id">Port</InputLabel>
          <Input
            type="number"
            value={this.state.dbPort}
            onChange={(e)=>this.handleTextfield(e,"dbPort")}
            error={this.state.dbPortErrorStatus}
          />
          <FormHelperText className="Mui-error">{this.state.dbPortErrorText}</FormHelperText>
         </FormControl>
         </ComponentErrorBoundary>
         </Col>
       </Row>

       <Row>
       <Col sm={4} xs={12} className=''>

         <Button label="Test connection" className='btn btn-default' onClick={this.testConnection.bind(this)} />

       </Col>

       </Row>
       {testDBStatus}
       </div>
       <div className="rounded-card margin-top-30">
        <div className="note">
          <p><span>Note:</span> Please make sure you test the connection and it's successful. You won't be able to save unsuccessful connections.</p>
          <p>This connection can be used with any schema on this server. Pick a schema later when creating Data Dictionaries, Lineage maps, or queries.</p>
        </div>
       <Row>
       <Col sm={4} xs={12}>
       <ComponentErrorBoundary value="DB connection name">
        <FormControl fullWidth>
         <InputLabel htmlFor="DB Id">Connection name</InputLabel>
         <Input
           type="text"
           value={this.state.dbName}
           onChange={(e)=>this.handleTextfield(e,"dbName")}
           error={this.state.dbNameErrorStatus}
           onBlur={this.validateField.bind(this,"dbName")}
         />
         <FormHelperText className="Mui-error">{this.state.dbNameErrorText}</FormHelperText>
        </FormControl>
        </ComponentErrorBoundary>
       </Col>
       </Row>
       <Row>
       <Col sm={4} xs={12} className=''>

        <Button label="Save" className='btn btn-action' disabled={this.state.saveButtonStatus} onClick={this.saveFlow.bind(this)}  />

         <Button label="Cancel" className='btn btn-default' onClick={this.cancelFlow.bind(this)} />

       </Col>

       </Row>
       </div>

         </div>
     }





     return (
       <div>

       {pageContent}

         </div>

     );
   }
}


const mapStateToProps = (state) => {
  return{
    isLoading: state.databaseReducer.isLoading,
    errors: state.databaseReducer.errorMessage
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {

  }
}


export default connect(mapStateToProps,mapDispatchToProps) (DBConnection);
